import PropTypes from 'prop-types';
import { Icon, OverlayTrigger, Tooltip } from '@openedx/paragon';
import { Lock } from '@openedx/paragon/icons';
import { useIntl } from '@edx/frontend-platform/i18n';

import messages from '../messages';

const LockedGradeCell = ({ snapshotData }) => {
  const intl = useIntl();

  const totalGrade = Array.isArray(snapshotData) && snapshotData.length > 0
    ? snapshotData.reduce((totals, item) => {
      const [earned = 0, possible = 0] = item.grade.split('/').map(Number);
      return {
        earned: totals.earned + earned,
        possible: totals.possible + possible,
      };
    }, { earned: 0, possible: 0 })
    : null;

  return (
    <OverlayTrigger
      placement="top"
      overlay={(
        <Tooltip id="locked-grade-tooltip">
          {intl.formatMessage(messages.lockedTooltip)}
        </Tooltip>
      )}
    >
      <span className="d-flex align-items-center justify-content-end text-muted">
        <Icon src={Lock} className="mr-1" style={{ height: '1rem', width: '1rem' }} />
        <span>{totalGrade ? `${totalGrade.earned}/${totalGrade.possible}` : intl.formatMessage(messages.lockedGrade)}</span>
      </span>
    </OverlayTrigger>
  );
};

LockedGradeCell.propTypes = {
  snapshotData: PropTypes.arrayOf(PropTypes.shape({
    grade: PropTypes.string.isRequired,
  })),
};

LockedGradeCell.defaultProps = {
  snapshotData: null,
};

export default LockedGradeCell;
